module.exports = __webpack_public_path__ + "img/telefonos-nn-1.c73f15f8.svg";